import utils from '@components/crm/utils';
import { Address } from 'types/Address';

type Args = {
  address: Address;
  showCounty?: boolean;
};

// Format's a user's address for display.
export const formatUserAddress = ({ address, showCounty }: Args): string[] => {
  try {
    if (!address) return [];

    const addressLines = [];

    if (address.address_line_one) addressLines.push(utils.handleTitleCase(address.address_line_one?.toLowerCase()));
    if (address.address_line_two) addressLines.push(address.address_line_two);

    // City, State, Zip
    let cityState = '';
    if (address.city && address.state) {
      cityState = `${utils.handleTitleCase(address.city?.toLowerCase())}, ${address.state}`;
    } else {
      cityState = `${utils.handleTitleCase(address.city?.toLowerCase()) || ''} ${address.state || ''}`;
    }
    if (address.zip_code) cityState = `${cityState} ${address.zip_code}`;
    addressLines.push(cityState);

    if (showCounty && address.county) addressLines.push(utils.handleTitleCase(address?.county));
    return addressLines;
  } catch (e) {
    console.log('formatUserAddress: ', e);
  }
};
